import { useAppActions } from 'reducers/slices/notificationSlice';
import { useSelector } from 'react-redux';

export default () => {
  const { sendMessageNotification } = useAppActions();
  const { loading } = useSelector(state => state.notificationSlice);

  return { sendMessageNotification, loading };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/useNotification.js